import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCcMastercard, faGoogle, faInstagram, faTiktok, } from "@fortawesome/free-brands-svg-icons";

import {
  faEye,
  faEyeSlash,
  faHeart as faRegularHeart,
  faSquareMinus,
  faCreditCard,
} from "@fortawesome/free-regular-svg-icons";

import {
  faStore,
  faList,
  faPuzzlePiece,
  faGift,
  faLink,
  faBell,
  faPrint,
  faClose,
  faLaptopFile,
  faTags,
  faClockRotateLeft,
  faTrash,
  faPencil,
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faAngleDown,
  faAngleRight,
  faArrowLeft,
  faHeart as faSolidHeart,
  faCircleMinus,
  faCirclePlus,
  faShoppingCart,
  faMoneyBills,
  faQrcode,
  faReceipt,
  faBookmark,
  faMagnifyingGlass,
  faLocationDot,
  faPhone,
  faShareNodes,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faMotorcycle,
  faBagShopping,
  faUtensils,
  faIceCream,
  faCookieBite,
  faPercent,
  faFilter,
  faX,
  faSignOut,
  faUsers,
  faWallet,
  faDoorOpen,
  faUserGear,
  faUserTie,
  faFloppyDisk,
  faDoorClosed,
  faInbox,
  faCalendarCheck,
  faTableCells,
  faClipboard,
  faTicket,
  faShop,
  faCircleInfo,
  faMars,
  faVenus,
  faRightFromBracket,
  faPlus,
  faArrowsRotate,
  faComments,
  faTimes,
  faPaperclip,
  faPaperPlane,
  faArrowRight,
  faTriangleExclamation,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faChartLine,
  faStore,
  faList,
  faPuzzlePiece,
  faGift,
  faLink,
  faBell,
  faPrint,
  faClose,
  faLaptopFile,
  faSignOut,
  faGoogle,
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faArrowLeft,
  faArrowRight,
  faSolidHeart,
  faRegularHeart,
  faSquareMinus,
  faCircleMinus,
  faCirclePlus,
  faShoppingCart,
  faMoneyBills,
  faQrcode,
  faReceipt,
  faBookmark,
  faMagnifyingGlass,
  faLocationDot,
  faPhone,
  faShareNodes,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faMotorcycle,
  faBagShopping,
  faUtensils,
  faIceCream,
  faCookieBite,
  faPercent,
  faFilter,
  faX,
  faPencil,
  faTrash,
  faClockRotateLeft,
  faTags,
  faUsers,
  faWallet,
  faDoorOpen,
  faUserGear,
  faUserTie,
  faFloppyDisk,
  faDoorClosed,
  faInbox,
  faCalendarCheck,
  faTableCells,
  faClipboard,
  faTicket,
  faShop,
  faCircleInfo,
  faMars,
  faVenus,
  faEye,
  faRightFromBracket,
  faEyeSlash,
  faPlus,
  faArrowsRotate,
  faComments,
  faTimes,
  faPaperclip,
  faAngleDown,
  faAngleRight,
  faPaperPlane,
  faCcMastercard,
  faCreditCard,
  faTriangleExclamation,
  faInstagram,
  faTiktok,
);

export { FontAwesomeIcon };
